import React, {useEffect, useState} from "react";
import Label from "./Label";

function TextInput(props) {
  const {id, label, name, value, onChange, error} = props;
  const [savedValue, setValue] = useState(value ?? '')

  useEffect(() => {
    if (value) {
      setValue(value)
    }
  }, [value])

  function onChangeHandler(event) {
    setValue(event.target.value);
    onChange && onChange(event.target.value)
  }

  return (
    <div className="form-group row">
      <Label htmlFor={id} label={label}/>
      <div className="col">
        <input
          id={id}
          type="text"
          className={["form-control", error && "is-invalid"].join(' ')}
          name={name}
          autoFocus
          value={savedValue}
          onChange={onChangeHandler}
        />
        {error &&
          <div className="invalid-feedback">
            <strong>{error}</strong>
          </div>
        }
      </div>
    </div>
  )
}

export default TextInput;